// extracted by mini-css-extract-plugin
export default {"root":"ButtonWin98_root__y-sH7"};